module.exports = __webpack_public_path__ + "img/Broken Prong.4cebae5e.png";